module.exports = __webpack_public_path__ + "static/media/logo-back.28d8e0f1.png";